import { Component, Input, OnInit } from '@angular/core';
import { ButtonsConfiguration, InfoButtonConfiguration } from 'src/app/models/buttons-config';
import { Record } from 'src/app/models/record';
import { RssItem } from 'src/app/models/rss';
import { ConfigService } from 'src/app/services/config.service';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-rss-item',
  templateUrl: './rss-item.component.html',
  styleUrls: ['./rss-item.component.scss'],
})
export class RssItemComponent implements OnInit {
  @Input()
  containerRecord: Record;

  @Input()
  item: RssItem;

  buttonsConfig: ButtonsConfiguration;

  constructor(private configService: ConfigService) {
    this.buttonsConfig = new InfoButtonConfiguration(this.configService.get().showReturnLoanButton);
  }

  ngOnInit() {}

  getRecordSlug(record: Record): string {
    return Util.slugifyRecord(record);
  }
}
